import { ValidatorConstraint, ValidatorConstraintInterface, ValidationArguments } from "class-validator";

@ValidatorConstraint({ name: "ExpenseFromToDateValid", async: false })
export class ExpenseFromToDateValid implements ValidatorConstraintInterface {
    validate(value: string, args: ValidationArguments) {
        const relatedObject = args.object as any; // Get the full object
        const dateRange = relatedObject.expense_type?.date_range; // Access `date_range`

        // console.log({ relatedObject, dateRange, value });

        // If dateRange is 0, always return true (no validation error)
        if (dateRange === 0) {
            return true;
        }

        // Otherwise, validate as a proper date (YYYY-MM-DD format)
        const datePattern = /^\d{4}-\d{2}-\d{2}$/; // Example: 2024-02-26
        return datePattern.test(value);
    }

    defaultMessage(args: ValidationArguments) {
        return `Invalid date format. Expected format: YYYY-MM-DD.`;
    }
}
